export const initModals = () => {
	window.entrio = window.entrio || {};
	
	const $html = document.querySelector('html');
	const $modals = document.querySelectorAll('.app-modal');

    window.entrio.showModal = function(target) {
        document.querySelector(`${target}`).classList.add('is-shown');
        $html.classList.add('with-open-modal');

        setTimeout(function() {
        	document.querySelector(`${target}`).classList.add('is-animated');
		}, 200);
    };

	window.entrio.closeModal = function(target) {
        document.querySelector(`${target}`).classList.remove('is-animated');
        $html.classList.remove('with-open-modal');

        setTimeout(function() {
        	document.querySelector(`${target}`).classList.remove('is-shown');
		}, 200);
    };

    if($modals.length) {
    	$modals.forEach(el => {
	    	el.addEventListener('click', event => {
	    		const mainParentEl = event.target.parentElement;

	    		if (mainParentEl.dataset.backdrop === 'true' && mainParentEl.classList.contains('is-shown')) {
	    			mainParentEl.classList.remove('is-animated');
			        $html.classList.remove('with-open-modal');

			        setTimeout(function() {
			        	mainParentEl.classList.remove('is-shown');
					}, 200);
	    		}
	    	})
	    })
    }
};

export const setupModalListener = (target) => {
	if (document.querySelector(`${target}`)) {
		const $html = document.querySelector('html');

		document.querySelector(`${target}`).addEventListener('click', event => {
    		const mainParentEl = event.target.parentElement;

    		if (mainParentEl.dataset.backdrop === 'true' && mainParentEl.classList.contains('is-shown')) {
    			mainParentEl.classList.remove('is-animated');
		        $html.classList.remove('with-open-modal');

		        setTimeout(function() {
		        	mainParentEl.classList.remove('is-shown');
				}, 200);
    		}
    	})
	}
}
